import { createAsyncAction } from 'typesafe-actions';
import { RegionsStoresResponse } from './types';

export const FETCH_REGIONS_AND_STORES = createAsyncAction(
  'businesUnits/FETCH_REGIONS_AND_STORES/request',
  'businesUnits/FETCH_REGIONS_AND_STORES/success',
  'businesUnits/FETCH_REGIONS_AND_STORES/failure',
  'businesUnits/FETCH_REGIONS_AND_STORES/cancel',
)<void, RegionsStoresResponse, Error | string, void>();
